import { get } from './utils';

const retrieve_table_type = async (
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = '/tabletype/retrieve';
    const result = await get(path);
    console.debug('retrieve_table_type', result);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

export { retrieve_table_type };
